var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 149.59,
    height: 149.59,
    viewBox: "0 0 149.59 149.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149.59,
    height: 149.59,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M149.589,74.8A74.8,74.8,0,1,1,74.794,0,74.795,74.795,0,0,1,149.589,74.8",
    transform: "translate(0 0)",
    fill: "#205583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.795,76.025A63.77,63.77,0,1,1,76.024,12.254a63.771,63.771,0,0,1,63.771,63.771",
    transform: "translate(-1.229 -1.229)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.873,140.994a65.12,65.12,0,1,1,65.12-65.119,65.193,65.193,0,0,1-65.12,65.119m0-127.541a62.421,62.421,0,1,0,62.421,62.421A62.492,62.492,0,0,0,75.873,13.453",
    transform: "translate(-1.079 -1.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.795,76.025A63.77,63.77,0,1,1,76.024,12.254a63.771,63.771,0,0,1,63.771,63.771",
    transform: "translate(-1.229 -1.229)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.873,140.994a65.12,65.12,0,1,1,65.12-65.119,65.193,65.193,0,0,1-65.12,65.119m0-127.541a62.421,62.421,0,1,0,62.421,62.421A62.492,62.492,0,0,0,75.873,13.453",
    transform: "translate(-1.079 -1.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.254,76.025a63.77,63.77,0,1,1,127.541,0Z",
    transform: "translate(-1.229 -1.229)",
    fill: "#205583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.994,77.224H10.754v-1.35a65.12,65.12,0,1,1,130.24,0Zm-127.526-2.7H138.28a62.421,62.421,0,0,0-124.813,0",
    transform: "translate(-1.079 -1.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.822,79.267H108.638L92.227,46.9l46.969.4a48.871,48.871,0,0,1,6.4,14.582,68.355,68.355,0,0,1,2.227,17.392",
    transform: "translate(-9.253 -4.705)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.672,80.466H108.487a1.35,1.35,0,0,1-1.2-.739L90.873,47.355a1.35,1.35,0,0,1,1.2-1.959h.012l46.969.4a1.351,1.351,0,0,1,1.085.562,49.92,49.92,0,0,1,6.6,15.018,69.074,69.074,0,0,1,2.274,17.777,1.351,1.351,0,0,1-1.35,1.315m-38.357-2.7h37a68.447,68.447,0,0,0-2.175-15.691,49.964,49.964,0,0,0-5.821-13.59l-44.037-.373Z",
    transform: "translate(-9.102 -4.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 24.748,
    transform: "translate(111.594 56.551)",
    fill: "#835e41"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.748,
    height: 2.699,
    transform: "translate(111.594 55.201)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.971,78.313h-26.3V42.033l12.99-4.65,13.31,4.65Z",
    transform: "translate(-4.482 -3.75)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.17,79.5h-29V40.923l14.335-5.131L72.17,40.916Zm-26.3-2.7h23.6V42.831L57.516,38.655,45.87,42.824Z",
    transform: "translate(-4.331 -3.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.399,
    y2: 23.037,
    transform: "translate(14.66 74.444)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 63.71,
    height: 2.699,
    transform: "matrix(0.932, -0.361, 0.361, 0.932, 14.169, 96.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.323,
    y2: 44.278,
    transform: "translate(28.422 74.743)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.091,
    height: 2.699,
    transform: "matrix(0.824, -0.567, 0.567, 0.824, 27.657, 117.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.34,
    y2: 62.23,
    transform: "translate(54.749 73.846)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 85.3,
    height: 2.7,
    transform: "matrix(0.684, -0.729, 0.729, 0.684, 53.759, 135.146)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.496,
    y2: 60.083,
    transform: "translate(97.233 74.496)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66.498,
    height: 2.699,
    transform: "matrix(0.428, -0.904, 0.904, 0.428, 96.021, 134.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.525,
    height: 16.155,
    transform: "translate(69.409 56.859)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.073,79.754H76.649V62.7h28.424Zm-27.524-.9h26.625V63.6H77.55Z",
    transform: "translate(-7.69 -6.29)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.38,67.6H81.327a2.509,2.509,0,0,0-2.509,2.509v9.145H58.748V63.1a2.508,2.508,0,0,1,1.386-2.244l27.6-13.8a2.512,2.512,0,0,1,2.244,0l27.6,13.8a2.508,2.508,0,0,1,1.387,2.244V79.258H98.889V70.112A2.509,2.509,0,0,0,96.38,67.6",
    transform: "translate(-5.894 -4.695)",
    fill: "#205583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.158,80.457H97.388v-10.5A1.16,1.16,0,0,0,96.229,68.8H81.176a1.161,1.161,0,0,0-1.16,1.159v10.5H57.248v-17.5a3.834,3.834,0,0,1,2.133-3.45l27.595-13.8a3.883,3.883,0,0,1,3.451,0l27.6,13.8a3.836,3.836,0,0,1,2.134,3.451Zm-20.071-2.7h17.372v-14.8a1.152,1.152,0,0,0-.641-1.036l-27.6-13.8a1.16,1.16,0,0,0-1.035,0l-27.6,13.8a1.149,1.149,0,0,0-.641,1.036v14.8h17.37v-7.8A3.863,3.863,0,0,1,81.176,66.1H96.229a3.863,3.863,0,0,1,3.858,3.858Z",
    transform: "translate(-5.743 -4.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.653,22.343a9.932,9.932,0,1,0,18.7-4.658,63.288,63.288,0,0,0-13.366-4.14,9.924,9.924,0,0,0-5.334,8.8",
    transform: "translate(-9.095 -1.359)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.434,33.465a11.278,11.278,0,0,1-5.224-21.275l.418-.219.462.089a64.791,64.791,0,0,1,13.652,4.229l.431.188.221.415a11.279,11.279,0,0,1-9.961,16.572M96.062,14.806a8.579,8.579,0,1,0,12.954,7.378,8.44,8.44,0,0,0-.8-3.611,62.05,62.05,0,0,0-12.156-3.767",
    transform: "translate(-8.944 -1.201)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 8.676,
    transform: "translate(40.09 42.835)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.676,
    height: 2.699,
    transform: "translate(40.09 41.486)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon_4.9993cce33d0ddccbd4dd7336ac564c9b.svg";
export { ForwardRef as ReactComponent };